import { setDayjsLanguage } from '@/dayjsSetup';
import { LanguageStore } from '@/types';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

export type LanguageType = 'en' | 'ar';

const useLanguageStore = create<LanguageStore>()(
  persist(
    (set) => ({
      language: 'ar',
      setLanguage: (lang: LanguageType) => {
        set({ language: lang });
        setDayjsLanguage(lang === 'en' ? 'en' : 'ar');
      },
    }),
    {
      name: 'language-storage',
      storage: typeof window !== 'undefined' ? createJSONStorage(() => localStorage) : undefined,
      onRehydrateStorage: () => (state) => {
        if (state?.language) {
          setDayjsLanguage(state.language);
          console.log('Rehydrated language:', state.language);
        }
      },
    },
  ),
);

export default useLanguageStore;
